<div>
	<app-components-togglepanel isOpen="true" title="Custom Reports" toggleBody="true">
		<compose Selector="app-components-customreports" [ActivateOptions]="{
                    customer: customer
                }"></compose>
    </app-components-togglepanel>
</div>